/**
 * Normalize API property_type / transaction values to a display label.
 * API may return 0/1, "sale", "sell", "rent", etc.
 */
export function getTransactionLabel(propertyType) {
  const t = String(propertyType ?? '').toLowerCase().trim();
  if (t === '0' || t === 'sale' || t === 'sell' || t === 'for sale' || t === 'for sell') {
    return 'Sale';
  }
  if (t === '1' || t === 'rent' || t === 'for rent') {
    return 'Rent';
  }
  return null;
}

/** Full badge text e.g. "For Sale" / "For Rent" */
export function getTransactionBadgeText(propertyType) {
  const label = getTransactionLabel(propertyType);
  if (!label) return 'Listing';
  return `For ${label}`;
}

/** Brand accent for sale/rent badges */
export const TRANSACTION_BADGE_STYLE = {
  backgroundColor: '#ff6f23',
  color: '#ffffff',
};
